import Vue from "vue";
import Vuex from "vuex";
import Category from "./modules/Category";
import Ingredients from "./modules/Ingredient";
import Suppliers from "./modules/Supplier";
import Supply from "./modules/Supply";
import Delivery from "./modules/Delivery";
import Receipts from "./modules/Receipt";
import ReceiptProduction from "./modules/ReceiptProduction";
import Customer from "./modules/Customer";
import Packing from "./modules/Packing";
import Order from "./modules/Order";
import User from "./modules/User";
import Pet from "./modules/Pet";
import DefaultCRUDService from "./services/DefaultCRUDService";
import StoreManagement from "./services/StoreManagement";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    category: Category,
    supplier: Suppliers,
    delivery: Delivery,
    supply: Supply,
    receiptProduction: ReceiptProduction,
    ingredient: Ingredients,
    customer: Customer,
    packing: Packing,
    pet: Pet,
    order: Order,
    user: User,
    receipt: Receipts
  },
  state: {
    selectedViewTitle: "",
    loggedUser: {}
  },
  mutations: {
    setSelectedViewTitle(state, title) {
      state.selectedViewTitle = title;
    },
    setLoggedUser(state, user) {
      state.loggedUser = user;
    },
    loadLoggedUser(state) {
      state.loggedUser = StoreManagement.getUser();
    }
  },
  actions: {
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        DefaultCRUDService.getItems("/users/me").then(
          ({ data }) => {
            commit("setLoggedUser", data);
            resolve(data);
          },
          error => {
            reject(error);
          }
        );
      });
    }
  },
  getters:{
    isUserAdmin(state){
      if(!state.loggedUser.groups || !state.loggedUser.groups.length) return false;
      return state.loggedUser.groups[0].id === 1
    }
  }
});
